import Banner from './variants/Banner';
import FooterEmailCapture from './variants/FooterEmailCapture';
import Inline from './variants/Inline';
import Modal from './variants/Modal';
var VariantMap = {
  banner: Banner,
  inline: Inline,
  modal: Modal,
  footer: FooterEmailCapture
};
export default VariantMap;